import "./FormContainer.scss";
import { useCallback } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import IndividualForm from "components/IndividualForm/IndividualForm";
import BusinessForm from "components/BusinessForm/BusinessForm";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "store";
import { exchangeActions } from "../../store/reducers/exchange";
import { useTranslation } from "react-i18next";
import { availableCurrencies } from "../../constants/availableCurrencies";

interface FormProps {
  isIndividualClient: boolean;
}
const Form = ({ isIndividualClient }: FormProps) => {
  const { from, to } = useAppSelector((state) => state.exchange);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const imageSrcFrom = availableCurrencies[from.symbol] || null;
  const imageSrcTo = availableCurrencies[to.symbol] || null;

  const backToCalculator = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("ExchangeCalculator"));
    navigate(window.location.pathname);
  }, [dispatch]);
  return (
    <div className="form-container">
      <div className="form-header">
        <div className="currency-section">
          <div className="currency-column">
            <div className="currency-text">{t("exchange.youGive")}</div>
            <div className="currency-value">
              <span className="amount">{from.amount}</span>
              {from.symbol}
            </div>
          </div>
          {imageSrcFrom && <img src={imageSrcFrom} alt={from.symbol} />}
        </div>
        <div className="arrow-area">
          <ArrowForwardIcon />
        </div>
        <div className="currency-section">
          <div className="currency-column">
            <div className="currency-text">{t('exchange.youReceive')}</div>
            <div className="currency-value">
              <span className="amount">{to.amount}</span>
              {to.symbol}
            </div>
          </div>
          {imageSrcTo && <img src={imageSrcTo} alt={to.symbol} />}
        </div>
      </div>
      {isIndividualClient ? (
        <IndividualForm backToCalculator={backToCalculator} />
      ) : (
        <BusinessForm backToCalculator={backToCalculator} />
      )}
    </div>
  );
};

export default Form;
